import { presetRange, type PeriodPreset } from "../../domain/funnel/period";
import type { ReportFilters } from "../types";

export type ReportParams = {
  preset: PeriodPreset;
  from: string;
  to: string;
  compare: boolean;
  filters: Required<
    Pick<
      ReportFilters,
      "sales_id" | "trade" | "region" | "source" | "category" | "mode"
    >
  >;
};
const PRESETS: readonly PeriodPreset[] = [
  "this_month",
  "last_month",
  "quarter",
  "custom",
];
const isIsoDate = (v: string | null): v is string =>
  !!v && /^\d{4}-\d{2}-\d{2}$/.test(v) && !Number.isNaN(Date.parse(v));

export const parseReportParams = (
  search: URLSearchParams,
  now: Date,
): ReportParams => {
  const raw = search.get("period");
  const preset = (
    PRESETS.includes(raw as PeriodPreset) ? raw : "this_month"
  ) as PeriodPreset;
  const from = search.get("from");
  const to = search.get("to");
  const range =
    preset === "custom" && isIsoDate(from) && isIsoDate(to) && from <= to
      ? { from, to }
      : presetRange(preset === "custom" ? "this_month" : preset, now);
  const rep = search.get("rep");
  return {
    preset,
    ...range,
    compare: search.get("compare") === "1",
    filters: {
      sales_id: rep && /^\d+$/.test(rep) ? Number(rep) : null,
      trade: search.get("trade") || null,
      region: search.get("region") || null,
      source: search.get("source") || null,
      category: search.get("category") || null,
      mode: search.get("view") === "snapshot" ? "snapshot" : "cohort",
    },
  };
};

/** True when a custom range was given with `from` after `to` (the parser then falls back to this month). */
export const isInvertedRange = (search: URLSearchParams): boolean => {
  const from = search.get("from");
  const to = search.get("to");
  return (
    search.get("period") === "custom" &&
    isIsoDate(from) &&
    isIsoDate(to) &&
    from > to
  );
};
